/* LUMINANTE : sélecteur de langue de la page du QR code.

   Le serveur rend toujours la première langue. Ce script ne fait que trois
   choses : présélectionner la langue du téléphone du visiteur, gérer le clic
   et le clavier, et inscrire le choix dans l'adresse.

   Sans JavaScript la page reste utilisable : la première langue est visible et
   les six étapes sont déjà dans le document, dans les cinq langues.

   Aucune bibliothèque, aucun écouteur de défilement, aucun stockage. */

(function () {
  var sections = document.querySelectorAll('[data-lum-qr]');
  if (!sections.length) return;

  /* La langue demandée dans l'adresse a toujours la priorité sur celle du
     téléphone : elle permet d'imprimer un QR code par marché. */
  function codeDemande() {
    try {
      var param = new URLSearchParams(window.location.search).get('lang');
      if (param) return param.trim().toLowerCase().slice(0, 2);
      var hash = (window.location.hash || '').replace('#', '').trim().toLowerCase();
      if (/^[a-z]{2}$/.test(hash)) return hash;
    } catch (e) {
      /* Une adresse mal formée ne doit pas empêcher la page de fonctionner. */
    }
    return '';
  }

  /* navigator.languages est une liste ordonnée par préférence : on la parcourt
     dans l'ordre plutôt que de ne lire que navigator.language, pour qu'un
     téléphone réglé en catalan puis en espagnol tombe bien sur l'espagnol. */
  function languesNavigateur() {
    var liste = [];
    if (navigator.languages && navigator.languages.length) {
      liste = Array.prototype.slice.call(navigator.languages);
    } else if (navigator.language) {
      liste = [navigator.language];
    }
    return liste.map(function (l) {
      return String(l).toLowerCase().slice(0, 2);
    });
  }

  sections.forEach(function (section) {
    var onglets = Array.prototype.slice.call(section.querySelectorAll('[data-lum-qr-code]'));
    if (onglets.length < 2) return;

    var panneaux = {};
    Array.prototype.forEach.call(section.querySelectorAll('[data-lum-qr-panneau]'), function (p) {
      panneaux[p.getAttribute('data-lum-qr-panneau')] = p;
    });

    var disponibles = onglets.map(function (o) {
      return o.getAttribute('data-lum-qr-code');
    });

    /* Sur téléphone les cinq langues ne tiennent pas dans la largeur : la
       piste défile. Sans ce recentrage, un visiteur allemand verrait la
       page en allemand mais l'onglet « Deutsch », lui, resterait hors écran,
       donc rien ne lui dirait quelle langue est active ni qu'il peut en
       changer.

       On agit sur le scrollLeft de la piste et jamais sur scrollIntoView,
       qui ferait aussi défiler la page verticalement au chargement. */
    function centrer(onglet) {
      var piste = onglet.parentElement;
      if (!piste || piste.scrollWidth <= piste.clientWidth) return;
      piste.scrollLeft = onglet.offsetLeft - (piste.clientWidth - onglet.offsetWidth) / 2;
    }

    function activer(code, deplacerFocus, ecrireAdresse) {
      if (disponibles.indexOf(code) === -1) return;

      onglets.forEach(function (onglet) {
        var actif = onglet.getAttribute('data-lum-qr-code') === code;
        onglet.setAttribute('aria-selected', actif ? 'true' : 'false');
        onglet.setAttribute('tabindex', actif ? '0' : '-1');
        if (actif && deplacerFocus) onglet.focus();
        if (actif) centrer(onglet);
      });

      Object.keys(panneaux).forEach(function (cle) {
        if (cle === code) {
          panneaux[cle].removeAttribute('hidden');
        } else {
          panneaux[cle].setAttribute('hidden', '');
        }
      });

      /* replaceState et non pushState : le bouton retour du téléphone doit
         ramener le visiteur d'où il vient, pas lui faire remonter ses
         changements de langue un par un. */
      if (ecrireAdresse && window.history && window.history.replaceState) {
        try {
          window.history.replaceState(null, '', '#' + code);
        } catch (e) {
          /* Sans effet sur l'affichage, la langue est déjà changée. */
        }
      }
    }

    onglets.forEach(function (onglet, index) {
      onglet.addEventListener('click', function () {
        activer(onglet.getAttribute('data-lum-qr-code'), false, true);
      });

      onglet.addEventListener('keydown', function (e) {
        var cible = -1;
        if (e.key === 'ArrowRight') cible = (index + 1) % onglets.length;
        if (e.key === 'ArrowLeft') cible = (index - 1 + onglets.length) % onglets.length;
        if (e.key === 'Home') cible = 0;
        if (e.key === 'End') cible = onglets.length - 1;
        if (cible === -1) return;
        e.preventDefault();
        activer(onglets[cible].getAttribute('data-lum-qr-code'), true, true);
      });
    });

    /* Choix initial. On n'écrit pas l'adresse ici : le visiteur n'a rien
       demandé, et un dièse apparu tout seul dans la barre d'adresse est du
       bruit. */
    var demande = codeDemande();
    if (demande && disponibles.indexOf(demande) !== -1) {
      activer(demande, false, false);
      return;
    }

    var prefs = languesNavigateur();
    for (var i = 0; i < prefs.length; i++) {
      if (disponibles.indexOf(prefs[i]) !== -1) {
        activer(prefs[i], false, false);
        return;
      }
    }
  });
})();
